export default __webpack_public_path__ + "pgnv-assets/c3c51134d49c59f92b1c4cff77ccc7b8.png";